import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef, useContext } from 'react';
// material
import { Box } from '@mui/material';
// contexts
import { SettingsContext } from '../contexts/Settings';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', ...other }, ref) => {
  const { metatags } = useContext(SettingsContext);

  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>
          {title} | {metatags.title}
        </title>
        <link rel="canonical" href={other.path} />
      </Helmet>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
